import { render, staticRenderFns } from "./FormRichtext.vue?vue&type=template&id=72b4a99f&"
import script from "./FormRichtext.vue?vue&type=script&lang=js&"
export * from "./FormRichtext.vue?vue&type=script&lang=js&"
import style0 from "./FormRichtext.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports